<template>
  <svg
    viewBox="0 0 600 80"
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMinYMid meet"
  >
    <text
      x="0"
      y="60"
      font-size="56"
      font-family="'Microsoft YaHei', 'PingFang SC', 'Arial', sans-serif"
      :fill="colorsComputed.start"
      font-weight="bold"
      dominant-baseline="middle"
    >
      O2Box报备系统
    </text>
  </svg>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useColors } from 'vuestic-ui'

const { getColor } = useColors()

const props = withDefaults(
  defineProps<{
    height?: number
    start?: string
    end?: string
  }>(),
  {
    height: 56,
    start: 'primary',
    end: undefined,
  },
)

const colorsComputed = computed(() => {
  return {
    start: getColor(props.start),
    end: getColor(props.end || props.start),
  }
})
</script>
